<!-- 无人机物流调度页面 -->
<template>
    <MainLayout rightWidth="40%" @toggleRight="onToggleRight" :hasRight="false">
        <News slot="header" :weatherDialogProps="weatherDialogProps"></News>
        <LeftAside slot="left" @listItemClick="handleLeftListItemClick"></LeftAside>

        <div ref="middlRef" slot="main" style="height: 100%; padding: 12px">
            <el-row style="height: 100%;" :gutter="20">
                <el-col :span="12" style="height: 100%;">
                    <MapContainer ref="mapRef" mapLayer="normal" :bottomToolConfig="bottomToolConfig">
                        <template slot="openlayer">
                            <LVector zIndex="100">
                                <LPointFeature v-for="item in siteList" :key="item.id" :longitude="item.longitude"
                                    :latitude="item.latitude" :id="item.id" :defaultStyle="markerStyle(item)">
                                </LPointFeature>
                            </LVector>
                            <OlAircrafts :aircraftList="aircraftList" :uavMap="aircraftMap" :siteMap="siteMap"
                                :showReturnLine="false"></OlAircrafts>
                        </template>
                        <template slot="legend">
                            <!-- 图例 -->
                            <div style="padding: 6px">
                                <div class="flex-align-center" v-for="(item, index) in mapLegendList" :key="index">
                                    <img v-if="item.image" :src="item.image" alt=""
                                        style="width: 24px; height: 24px; margin-right: 4px;">
                                    <span>{{ item.label }}</span>
                                </div>
                            </div>
                        </template>
                    </MapContainer>
                </el-col>
                <el-col :span="12" style="height: 100%;">
                    <VideoGrid v-if="rightVisible" :videoList="videoList" :treeData="videoTreeData" :showTree="true"
                        :showTitle="false" :treeProps="treeProps" :splitCount="6">
                    </VideoGrid>
                </el-col>
            </el-row>

        </div>
        <div slot="right" style="height: 100%; padding: 12px;">
            <VideoGrid v-if="rightVisible" :videoList="videoList"></VideoGrid>
        </div>

    </MainLayout>
</template>

<script>
import { LVector, LPointFeature } from '@OpenLayersCommon';
import { mapGetters } from 'vuex';
import News from '@/page/mainPage/components/news/News.vue';
import MainLayout from '@/components/layout';
import MapContainer from '@/components/map/MapContainer/MapContainer.vue';
import LeftAside from './components/LeftAside.vue';
import SiteApi from '@/page/business/wuliu/api/site';
import VideoGrid from '@/components/VideoGrid';
import DroneApi from '@/api/flight/drone';
import { DeliveryOrderStatus } from '@/page/business/wuliu/constants';
import { treeToListDrone } from '@/utils/common';
import OlAircrafts from '@/page/mainPage/mapComponents/Aircrafts.vue';
import GModule from '@/page/globalModule';

export default {
    components: {
        MainLayout,
        News,
        LeftAside,
        LVector,
        LPointFeature,
        MapContainer,
        VideoGrid,
        OlAircrafts,
    },
    props: {},

    data() {
        document.title = '物流调度';
        return {
            siteList: [],
            siteListMap: {},
            droneTreeData: [], // 无人机树状数据
            currentOrder: null, // 左侧列表当前选中项
            rightVisible: true,
            siteCameras: [], // 站点定点监控摄像头
            treeProps: {
                nodeKey: 'id',

                props: {
                    children: 'children',
                    label: 'name',
                },

            },
            bottomToolConfig: {
                showFly: false,
            },
        };
    },
    computed: {
        videoList() {
            let list = [].concat(this.droneVideoList);
            if (this.filterSiteCamerasTree) {
                this.filterSiteCamerasTree.forEach((item) => {
                    if (item.children) {
                        list = list.concat(item.children);
                    }
                });
            }

            return list;
        },
        // 无人机视频列表
        droneVideoList() {
            // console.log(this.dockMap, 'dockMap')
            // console.log(this.aircraftList, 'aircraftList')
            let videoResult = [];
            let droneList = [];
            treeToListDrone(this.droneTreeData, droneList);
            // console.log(droneList, 'droneList')
            const dockMap = this.dockMap;

            for (let i = 0; i < droneList.length; i++) {
                const item = droneList[i];
                if (this.currentOrder) {
                    // 过滤当前订单的无人机
                    if (this.currentOrder.droneId && this.currentOrder.droneId !== item.droneId) {
                        continue;
                    }
                }

                if (item.droneOnlineState) {
                    let obj = {
                        src: item.firstView,
                        info: item,
                        name: item.droneName,

                    };
                    const gatewaySn = item.dockSn;
                    const dock = dockMap[gatewaySn];
                    // console.log({ ...dock }, 'dock')
                    // console.log(JSON.parse(JSON.stringify(this.aircraftMap)), 'aircraftMap')
                    if (dock) {
                        const videoList = dock.videoURL || [];

                        let firstView = null;
                        let fpvView = null;
                        videoList.forEach((videoItem) => {
                            const { domain, view } = videoItem;
                            if (domain == 'drone') {
                                if (view == 'first') {
                                    firstView = videoItem;
                                } else if (view == 'fpv') {
                                    fpvView = videoItem;
                                } else {
                                    firstView = videoItem;
                                }
                            }
                        });
                        if (firstView) {
                            obj.src = firstView.webrtcUrl || firstView.flvUrl || firstView.hlsUrl;
                        } else if (fpvView) {
                            obj.src = fpvView.webrtcUrl || fpvView.flvUrl || fpvView.hlsUrl;
                        }
                    }
                    videoResult.push(obj);
                }
            }

            return videoResult;
        },
        // 过滤后的站点摄像头树状数据
        filterSiteCamerasTree() {
            if (this.currentOrder) {
                return this.siteCameras.filter((item) => item.id == this.currentOrder.startSiteId || item.id == this.currentOrder.endSiteId);
            } else {
                return this.siteCameras;
            }
        },
        // 视频树状数据
        videoTreeData() {
            let treeData = [];
            let obj = {
                id: 'droneVideo',
                name: '无人机视频',
                nodeType: 'folder',
                children: this.droneVideoList || [],
            };

            let obj2 = {
                id: 'siteCamera',
                name: '站点摄像头',
                nodeType: 'folder',
                children: this.filterSiteCamerasTree || [],
            };
            treeData.push(obj);
            treeData.push(obj2);

            return treeData;
        },
        // 天气弹窗props
        weatherDialogProps() {
            let res = {
                showDefaultText: true,
                useWeatherStation: true,
                weatherStationId: "",
                weatherDeviceSn: "",
            }
            if (this.currentOrder) {
                const endSiteId = this.currentOrder.endSiteId || '';
                let siteInfo = this.siteListMap[endSiteId || ''];
                res.weatherStationId = endSiteId
                res.weatherDeviceSn = siteInfo.weatherDeviceSn || ''

            }

            return res

        },
        /**
     * 地图图例
     */
        mapLegendList() {
            return [
                {
                    label: '配送站',
                    value: '',
                    image: require('@/assets/images/wuliu/chuku.png'),
                },
                {
                    label: '收货站',
                    value: '',
                    image: require('@/assets/images/wuliu/shouhuo.png'),
                },

            ];
        },
        /**
 * aircraftList 在线无人机列表
 * taskProcessMap 无人机任务进度
 */
        ...mapGetters('Aircraft', ['taskProcessMap', 'siteMap', 'dockMap', 'aircraftMap', 'aircraftList']),
    },
    methods: {
        markerStyle(data) {
            const { type } = data || {};
            let src = require('@/assets/images/wuliu/chuku.png');
            let name = data.name || '';
            if (type == 'T') {
                // 收货站
                src = require('@/assets/images/wuliu/shouhuo.png');

                name += '(收货站)';
            } else {
                name += '(配送站)';
            }
            let result = {
                icon: {
                    src,
                    // width: 10,
                    // height: 10,
                    scale: 0.8,
                },
                text: {
                    text: name,
                    font: '12px sans-serif',
                    offsetY: 20,
                    stroke: {
                        color: '#ffffff',
                        width: 2,
                    },

                },
            };
            return result;
        },
        onToggleRight(val) {
            this.rightVisible = val;
        },
        getSiteList() {
            let params = {
                // type: 'D'//站点类型   D：配货站点   T：取货站点
            };
            SiteApi.fetchSiteList(params).then((res) => {
                if (res.code == 200) {
                    this.siteList = res.rows || [];
                    let siteMap = {};
                    this.siteList.forEach((item) => {
                        siteMap[item.id] = item;
                    });
                    this.siteListMap = siteMap;
                }
            });
        },

        getDroneList() {
            let params = {
                pageNum: 1,
                pageSize: 10,
            };
            DroneApi.getDroneList(params).then((res) => {
                if (res.code == 200) {
                    this.droneTreeData = res.data || [];
                }
            });
        },
        /**
    * 左侧列表项点击事件
    */
        handleLeftListItemClick(item) {
            this.currentOrder = item;

            if (!item) return;
            const status = item.status || 0;

            let siteId = item.startSiteId;
            if (status > Number(DeliveryOrderStatus.DELIVERING.value)) {
                siteId = item.endSiteId;
            }
            SiteApi.fetchServiceSiteInfo(siteId).then((res) => {

                if (res.code == 200) {
                    const siteDetail = res.data || {};

                    const { longitude, latitude } = siteDetail || {};
                    if (longitude && latitude && this.$refs.mapRef) {
                        this.$refs.mapRef.toCenter([longitude, latitude]);
                    }
                }
            });
        },

        /**
     * 获取配送站的摄像头列表
     */
        getSiteCameras() {
            SiteApi.fetchSiteCameras().then((res) => {
                if (res.code == 200) {
                    const siteCameras = res.data || [];
                    this.siteCameras = siteCameras;
                }
            });
        },
        /**
   * 定时刷新数据
   */
        timerGetData() {
            clearInterval(this.timerId);
            this.getDroneList();
            this.timerId = setInterval(() => {
                this.getDroneList();
            }, 1000 * 20);
        },
    },
    mounted() {
        this.getSiteList();
        this.timerGetData();
        // 初始化无人机websocket
        GModule.AircraftModule.init();

        this.getSiteCameras();
    },
    beforeDestroy() {
        clearInterval(this.timerId);
        if (GModule.AircraftModule) {
            GModule.AircraftModule.closeWebsocket();
        }
    },
};
</script>

<style lang="scss" scoped></style>
